import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import moment from 'moment';
import { orderBy, range } from 'lodash';

import { CycleMenuDetailsFieldEnum as Fields } from 'Common/FieldEnum';
import {
  MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME,
  InputMode,
} from 'Common/FormEnum';
import { InputField, SelectField } from 'Common/SemanticWrapper';
import { TitledCard } from 'Components/';
import { NutritionalStandard } from 'Common/Constants/NutritionalStandard';

const NutritionStandardOptions = orderBy(
  NutritionalStandard.map((item, index) => {
    return { key: index, value: item.id, text: item.description };
  }),
  'value',
  'desc'
);

const AnalysisDaysOptions = range(3, 8).map(day => ({
  key: day,
  value: day,
  text: `${day} Days`,
}));

const currentYear = moment().year();
const FiscalYearOptions = range(currentYear - 10, currentYear + 11).map(
  year => ({
    key: year,
    value: year,
    text: year,
  })
);

class CycleMenuDetailsFormContainer extends Component {
  getTitle = () => {
    const { editing } = this.props;
    return editing ? 'Edit Cycle Menu' : 'Add New Cycle Menu';
  };

  render() {
    return (
      <Form>
        <TitledCard title={this.getTitle()}>
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column width={5}>
                <Field
                  component={InputField}
                  label={'Menu Title'}
                  maxLength={40}
                  name={Fields.Description}
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name={Fields.FiscalYear}
                  component={SelectField}
                  type="text"
                  label={'Fiscal Year'}
                  options={FiscalYearOptions}
                  fluid
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  component={InputField}
                  name={Fields.Servings}
                  label={'Planned Servings'}
                  mode={InputMode.Integer}
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  component={InputField}
                  name={Fields.NumberOfDaysInCycle}
                  label={'# of Days In Cycle'}
                  mode={InputMode.Integer}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4}>
                <Field
                  name={Fields.NutritionStandardId}
                  component={SelectField}
                  label={'Nutritional Standard'}
                  options={NutritionStandardOptions}
                  fluid
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <Field
                  name={Fields.AnalysisDays}
                  component={SelectField}
                  label={'Analysis Days'}
                  options={AnalysisDaysOptions}
                  fluid
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values[Fields.Description]) {
    errors[Fields.Description] = 'Description Required';
  }
  if (!values[Fields.Servings]) {
    errors[Fields.Servings] = 'Servings Required';
  } else {
    if (Number(values[Fields.Servings]) <= 0) {
      errors[Fields.Servings] = 'Number of Servings must be greater than zero.';
    }
    if (Number(values[Fields.Servings]) > 9999) {
      errors[Fields.Servings] = 'Number of Servings cannot exceed 9999.';
    }
  }

  if (!values[Fields.NumberOfDaysInCycle]) {
    errors[Fields.NumberOfDaysInCycle] = 'Number of Days Required';
  } else {
    if (Number(values[Fields.NumberOfDaysInCycle]) <= 0) {
      errors[Fields.NumberOfDaysInCycle] =
        'Number of Days must be greater than zero.';
    }
    if (Number(values[Fields.NumberOfDaysInCycle]) > 50) {
      errors[Fields.NumberOfDaysInCycle] = 'Number of Days cannot exceed 50.';
    }
  }

  if (!values[Fields.NutritionStandardId]) {
    errors[Fields.NutritionStandardId] = 'Nutrition Standard Required';
  }

  return errors;
};

const CycleMenuDetailsForm = reduxForm({
  form: MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME,
  validate,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(CycleMenuDetailsFormContainer);

export { CycleMenuDetailsForm };



// WEBPACK FOOTER //
// ./src/pages/managemenu/tabs/CycleMenuDetailsForm.js